<template>
  <div>
    <NavBar v-if="titleShow||claimsStatusCode!=undefined"></NavBar>
    <div class="c-zxrpr6">
      <div>
        <h1><center class="c-zxrpr6-title c-claim-title">理赔咨询服务及收费标准</center></h1>
        <h3>服务详情如下：</h3>
        <section>
          1.出具评议书：出具评议书，由您借此评议书与保险公司协商理赔，300元/份。
        </section>
        <section>
          2.协商协谈：经您授权，由我司代表您与保险公司协商协谈，若协谈成功，将收取争议金额的20%作为咨询服务费，若协谈不成功，则不收取任何费用。 
        </section>
        <section>
          3.诉讼服务：如我司协商协谈不成功，经您授权转交由第三方律师事务所进行诉讼，若诉讼成功，将收取争议金额的25%作为诉讼费，若诉讼不成功，则收取基本律师服务费1万。
        </section>
        <section>
           注：争议金额=保险合同约定的保额-协谈/诉讼前保险公司已赔付或书面通知赔付的金额（含保险金或补偿金给付、保费豁免或返还保费金额）
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/h5header'
import { isApp } from '@/utils/platform'
export default {
  components: { NavBar },

  data() {
    return {
      titleShow: false,
      claimsStatusCode:undefined,
    }
  },
   created() {
     if(this.$route.query) {
      this.claimsStatusCode = this.$route.query.claimsStatusCode
      // this.userId = this.$route.query.userId
      // console.log(this.claimsStatus,222)
    }
    if(!isApp) {
      this.titleShow = true
    }
  },
}
</script>
<style scoped lang="less">
.c-zxrpr6 {
  padding: 15px;
  font-size: 16px;
  &-title {
    color: @c-color-primary;
  }
}
.c-claim-title {
  font-size: 20px;
  color: black;
}
</style>